<script setup lang="ts">
import { VApp } from 'vuetify/components'
import Post from './Post.vue'

const props = defineProps({
  server: String,
  toot: String,
})
</script>

<template>
  <link
    rel="stylesheet"
    type="text/css"
    href="https://cdn.jsdelivr.net/npm/vuetify@3/dist/vuetify.min.css"
  />
  <link
    rel="stylesheet"
    type="text/css"
    href="https://cdn.jsdelivr.net/npm/@mdi/font@7.4.47/css/materialdesignicons.min.css"
  />

  <v-app>
    <suspense>
      <Post :server="props.server" :toot="props.toot" />
    </suspense>
  </v-app>
</template>
